import { breakpointSizes } from 'components/utils/breakpoint'

export const DesktopLayoutSizes = `@media (min-width: ${breakpointSizes.sm.min}px) and (max-width: ${breakpointSizes.sm.max}px), (min-width: ${breakpointSizes.lg.min}px)`
